export default "__VITE_ASSET__eYIyUHix__"